import { Typography } from '@mui/material'

import { AcqType, SbpType } from '../../types.ts'
import { EMPTY_VALUE } from '../../constants.ts'

const ACQ_OPERATION_TYPE_LABELS: Record<SbpType | AcqType, string> = {
  INCOME: 'Поступление C2B',
  INCOME_B2B: 'Поступление B2B',
  REVERSE: 'Возврат',
  INCOME_ACCOUNT: 'Пополнение счета',
  PAY_BASKET: 'Оплата корзины',
}

const OPERATION_TYPE_LABELS: Record<SbpType | AcqType, string> = {
  INCOME: 'Оплата',
  INCOME_B2B: 'Оплата',
  REVERSE: 'Возврат',
  INCOME_ACCOUNT: 'Пополнение счета',
  PAY_BASKET: 'Оплата корзины',
}

const PAYMENT_LABELS: Record<SbpType | AcqType, string> = {
  INCOME: 'C2B',
  INCOME_B2B: 'B2B',
  REVERSE: 'C2B',
  INCOME_ACCOUNT: 'Пополнение счета',
  PAY_BASKET: 'Оплата корзины',
}

interface OperationTypeProps {
  value: SbpType | null
  paymentTypeLabels?: boolean
}
export const OperationType = ({ value, paymentTypeLabels = false }: OperationTypeProps) => {
  const Dictionary = paymentTypeLabels ? PAYMENT_LABELS : OPERATION_TYPE_LABELS
  return <Typography>{value ? Dictionary[value] : EMPTY_VALUE}</Typography>
}
export const AcqOperationType = ({ value }: OperationTypeProps) => {
  return <Typography>{value ? ACQ_OPERATION_TYPE_LABELS[value] : EMPTY_VALUE}</Typography>
}
